import React from "react";
import { Badge, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { HOME_BANNER } from "../../../assets";
import { NoticiaListItemVM } from "../../../types/viewModels/cmsPublic";
import "./styles.scss";

export interface NewsCardProps {
  noticia: NoticiaListItemVM;
}

const NewsCard: React.FC<NewsCardProps> = ({ noticia }) => {
  const { t } = useTranslation("news");
  const navigate = useNavigate();

  return (
    <Card
      className="w-100 h-100 news-card"
      onClick={() => navigate(noticia.href)}
    >
      <Card.Img
        variant="top"
        className="news-card-img"
        src={noticia.imageUrl || HOME_BANNER}
        alt={noticia.title}
      />
      <Card.Body className="d-flex flex-column">
        {noticia.categories.length > 0 && (
          <div className="d-flex flex-row flex-wrap gap-1 mb-2">
            {noticia.categories.map((category, position) => (
              <Badge
                key={`${category.slug}-${position}`}
                className="news-card-badge"
              >
                {category.nombre || category.slug}
              </Badge>
            ))}
          </div>
        )}
        {noticia.publishedAtLabel && (
          <time className="news-card-date mb-1" dateTime={noticia.publishedAt}>
            {noticia.publishedAtLabel}
          </time>
        )}
        <Card.Title className="news-card-title clamp-text">
          {noticia.title}
        </Card.Title>
        {noticia.summary && (
          <Card.Text className="news-card-summary clamp-text">
            {noticia.summary}
          </Card.Text>
        )}
        <span className="news-card-link mt-auto">{t("readMore")}</span>
      </Card.Body>
    </Card>
  );
};

export default NewsCard;
